import React from "react";
import { Route, Switch } from "react-router-dom";
import DemoSpacesPageLayout from "./DemoSpacesRouteWrapper";
import { demoSpaceRoutes } from "./routes";

const DemoSpacesRouter = () => {
  return (
    <DemoSpacesPageLayout>
      <Switch>
        {demoSpaceRoutes.map((route, index) => (
          <Route key={index} exact={route.exact} path={route.path}>
            <route.component />
          </Route>
        ))}
      </Switch>
    </DemoSpacesPageLayout>
  );
};

export default DemoSpacesRouter;
